import {z} from 'zod'

export const setDiligenciaHistoricoFormSchema = z.object({
  id_empresa: z.number().optional(),
  id_proprietario: z.number(),
  id_terreno: z.number().optional(),
  id_user: z.number().optional(),
})

export type setDiligenciaHistoricoFormData = z.infer<typeof setDiligenciaHistoricoFormSchema>

export const putDiligenciaHistoricoFormSchema = z.object({
  id: z.number(),
  id_empresa: z.number().optional(),
  id_proprietario: z.number(),
  id_terreno: z.number().optional(),
  id_user: z.number().optional(),
})

export type putDiligenciaHistoricoFormData = z.infer<typeof putDiligenciaHistoricoFormSchema>
